import { BusinessUnit } from 'types/dsi';
import { SiteTableType } from 'types/protein';
import { SiteTable } from '../../../components/SiteTable/SiteTable';
import { SiteMachinesTableWidgetContainer } from './SiteMachinesTableWidget.element';

interface Props {
  plantId: string;
  type: SiteTableType;
  businessUnit?: string | undefined;
}

export const SiteMachinesTableWidget = ({ plantId, type, businessUnit }: Props): JSX.Element => {
  const isDSI = businessUnit === BusinessUnit.DSI;
  return (
    <SiteMachinesTableWidgetContainer>
      <SiteTable
        plantId={plantId}
        type={type}
      />
    </SiteMachinesTableWidgetContainer>
  );
};

export default SiteMachinesTableWidget;
